export const imageGridGql = /* GraphQL */ `
... on landingPageContent2023_imageGrid_BlockType {
    typeHandle
    title:imageGridTitle
    variant:imageGridVariant
    theme:imageGridTheme
    grid:imageGrid {
        ... on images_Asset {
            alt:altText
            title
            caption
            image:galleryThumbnail {
                srcWebp
                srcset
            }
            imageFull:lpImageTextUncropped {
                srcWebp
                srcset  
            }
        }
    }
}`;
